export const fallbackError = {
  code: "UNKNOWN",
  message: "Неизвестная ошибка",
};

export const statusMessages = {
  400: "Ошибка запроса",
  401: "Запрос запрещен",
  403: "Ошибка авторизации",
  404: "Не найдено",
  500: "Неизвестная ошибка",
  default: fallbackError.message,
};

export function getStatusMessage(status: number | null) {
  if (!status) return statusMessages.default;
  return status in statusMessages
    ? // @ts-ignore
      statusMessages[status]
    : statusMessages.default;
}
